import { Component } from "react";
import logo from '../me-tri.jpg';

class MainPageImage extends Component {
  render() {
    return (
      <img src={logo} className="Homepage-img" alt="Falmouth Triathlon" />
    )
  }
}

export default MainPageImage;